import Create from './create/CreateEmail';
import Edit from './edit/EditEmail';
import Individual from './individual/Email';
import List from './list/Emails';

export default { List, Edit, Create, Individual };
